export enum EffectsEnum {
  SSAO = 'sao',
  Blur = 'blur',
  RadialBlur = 'radialBlur',
  DOF = 'dof',
  FXAA = 'fxaa',
  GroundShadow = 'groundShadow',
}
